import { render, staticRenderFns } from "./PrintReceipt.vue?vue&type=template&id=683df2a6&scoped=true&"
import script from "./PrintReceipt.vue?vue&type=script&lang=js&"
export * from "./PrintReceipt.vue?vue&type=script&lang=js&"
import style0 from "./PrintReceipt.vue?vue&type=style&index=0&id=683df2a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683df2a6",
  null
  
)

export default component.exports